import api from ".";
import { getToken } from "../Auth/Token";

const getAuthConfig = () => {
  const token = getToken();
  if (!token) {
    throw new Error("Authentication token is missing");
  }

  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
};

export const getMandatoryFields = async (productType) => {
  try {
    const query =
      productType ? `?productType=${encodeURIComponent(productType)}` : "";
    const { data } = await api.get(
      `api/settings/mandatory-fields${query}`,
      getAuthConfig(),
    );
    return data;
  } catch (error) {
    console.error("getMandatoryFields failed:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      code: error.code, 
    });

    throw {
      success: false,
      message:
        error.response?.data?.message ||
        "Failed to fetch mandatory fields. Please try again.",
      status: error.response?.status,
      error, 
    };
  }
};

export const updateMandatoryFieldsBulk = async (fieldsArray, productType) => {
  if (!Array.isArray(fieldsArray) || fieldsArray.length === 0) {
    throw new Error("fieldsArray must be a non-empty array");
  }

  try {
    const { data } = await api.post(
      "api/settings/mandatory-fields/bulk-update",
      { fields: fieldsArray, productType },
      getAuthConfig()
    );

    return data;
  } catch (error) {
    console.error("updateMandatoryFieldsBulk failed:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      fieldsCount: fieldsArray.length,
    });

    throw {
      success: false,
      message:
        error.response?.data?.message ||
        "Failed to update mandatory fields. Please try again.",
      status: error.response?.status,
      error,
    };
  }
};
